import { useContext, useEffect, useState } from "react";
import * as _btn_ from "@Elementos/Boton";
import * as _div_ from "@Elementos/Div";
import * as _f_ from "@Funciones/funciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import { Contexto } from "@Componentes/App";

import "./PostConfirmacion.css";
export const PostConfirmacion = ({
  origen,
  texto,
  fBotonDeAcuerdo,
  accion,
  children
}) => {
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [v_u, ev_u] = useState({
    d_exito: false,
    i_procesandoApi: false,
  });

  useEffect(()=>{
    accion?.()
  },[])
  return (
    <>
      <_div_.Div texto={texto} />
      <div className={"PostConfirmacionCSS-contenido"}>{children}</div>
      <div className={"PostConfirmacionCSS-opciones"}>
        <_btn_.Boton
          texto={`De acuerdo`}
          tipo="btn-2"
          procesando={v_u.i_procesandoApi}
          estilos={{
            anchoB2: "7rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            fBotonDeAcuerdo?.();
          }}
        />
      </div>
    </>
  );
};
